import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ModelService} from './model-service';
import {Observable} from 'rxjs';
import {SureFlowPipe} from '../model/sure-flow-pipe';
import {SureFlowRequest} from '../model/sure-flow-request';
import {SureFlowResponse} from '../model/sure-flow-response';

@Service()
export class RatingSureFlowService {
  private readonly http = inject(HttpClient);
  private readonly modelService = inject(ModelService);


  private readonly URL_BASE: string = environment.ratingsBaseUrl;
  private readonly API_KEY: string = '1E9FCDA9-0AF0-484E-B710-0CBAFAA6E605';

  getLoopRating(request: SureFlowRequest): Observable<SureFlowResponse> {
    const url: string = this.URL_BASE + '/sureFlowLoop';
    return this.http.post<SureFlowResponse>(url, JSON.stringify(request), {headers: this.getPostHeaders('application/json', 'application/json')});
  }

  getSureFlowLoopPipes(): Observable<SureFlowPipe[]> {
    const url: string = this.URL_BASE + '/lookups/sureFlowPipes';
    return this.http.get<SureFlowPipe[]>(url, {headers: this.getRequestHeaders('application/json')});
  }

  private getPostHeaders(contentType: string, acceptType: string) {
    return this.getRequestHeaders(acceptType).set('Content-Type', contentType);
  }

  private getRequestHeaders(acceptType: string) {
    return new HttpHeaders().set('Accept', acceptType).set('ApiKey', this.API_KEY);
  }

}
